<template>
<div class="file-upload">
    <button type="button" @click="onButtonClick">Choose File</button>
    <input disabled type="text" v-model="filename" />
    <input class="input" ref="input" type="file" @change="onFileChange($event)" />
</div>
</template>

<script>
export default {
    name: "file-upload",

    data () {
        return {
            file: null
        }
    },

    computed: {
        filename: function () {
            if (this.file && this.file.name) {
                return this.file.name
            } else {
                return ""
            }
        }
    },

    methods: {
        /**
         * When the stylized button is clicked, trigger a click event on the actual file input.
         */
        onButtonClick: function () {
            this.$refs.input.dispatchEvent(new MouseEvent("click"))
        },

        onFileChange: function (event) {
            if (event.target.files) {
                this.file = event.target.files[0]
            } else {
                this.file = null
            }

            this.$emit("change", this.file)
        }
    }
}
</script>

<style>
.file-upload {
    align-items: center;
    display: flex;
}

.file-upload button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    flex: 0;
    white-space: nowrap;
}

.file-upload .input {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUpload.vue